<div class="initials">{{ getInitials() }}</div>
